import { LANGUAGES } from '@vindr/services/constants/common.constant';
import { DefinedColumns } from '@vindr/services/interfaces';
import { useTranslation } from 'react-i18next';

const StatusColumn = <T,>(props?: Partial<DefinedColumns<T>>): DefinedColumns<T> => {
  const {
    title,
    dataIndex = 'active' as keyof T,
    width = 70,
    key = 'active' as keyof T,
    sorter,
    ellipsis = true,
    render,
    ...rest
  } = props || {};

  const { t, i18n } = useTranslation('Vindoc');

  return {
    title: title || t('Status'),
    dataIndex,
    key,
    width: i18n.language === LANGUAGES.VI ? Number(width) + 50 : width,
    sorter,
    ellipsis,
    render: render || ((text) => (['true', true].includes(text) ? t('Active') : t('Inactive'))),
    ...rest,
  };
};

export default StatusColumn;
